import "./App.css";
import Landing from "./Components/landing/Landing";
import Routes from "./Routes/Routes";

function App() {
  return <Routes />;
}

export default App;
